'use strict';

define(['utils/helpers', 'handlebars-loader!templates/rightclick.html', 'utils/underscore', 'utils/ui', 'version'], function (utils, rightclickTemplate, _, UI, version) {

    var RightClick = function RightClick() {};

    _.extend(RightClick.prototype, {
        buildArray: function buildArray() {
            var semverParts = version.split('+');
            var majorMinorPatchPre = semverParts[0];

            var obj = {
                items: []
            };
            var rightclick = this.model.get('rightclick');
            if (rightclick && _.isArray(rightclick) && rightclick.length > 0) {
                _.each(rightclick, function (rightclickItem) {
                    obj.items.push({
                        title: rightclickItem.title,
                        link: rightclickItem.link
                    });
                });
            } else {
                obj.items.push({
                    title: 'About Cyber Player ' + majorMinorPatchPre,
                    link: 'https://bce.baidu.com/doc/MCT/Web-SDK.html' + '#.E6.92.AD.E6.94.BE.E5.99.A8.20Web.20SDK.20.E7.AE.80.E4.BB.8B'
                });
            }

            var _provider = this.model.get('provider');
            if (_provider && _provider.name.indexOf('flash') >= 0) {
                var text = 'Flash Version ' + utils.flashVersion();
                obj.items.push({
                    title: text,
                    link: 'http://www.adobe.com/software/flash/about/'
                });
            }

            return obj;
        },
        buildMenu: function buildMenu() {
            var obj = this.buildArray();
            return utils.createElement(rightclickTemplate(obj));
        },
        updateHtml: function updateHtml() {
            this.el.innerHTML = this.buildMenu().innerHTML;
        },

        rightClick: function rightClick(evt) {
            this.lazySetup();

            if (this.mouseOverContext) {
                // right click on menu item should execute it
                return false;
            }

            this.hideMenu();
            this.showMenu(evt);

            return false;
        },

        getOffset: function getOffset(evt) {
            var target = evt.target;
            // offsetX is from the W3C standard, layerX is how Firefox does it
            // 修复IE下右键定位不准问题
            var x = evt.layerX || evt.offsetX;
            var y = evt.layerY || evt.offsetY;
            if (utils.isIE() && (utils.hasClass(target, 'jw-video') || utils.hasClass(target, 'jw-warning'))) {
                return { x: x, y: y + 40 };
            }
            while (target !== this.playerElement) {
                x += target.offsetLeft;
                y += target.offsetTop;

                target = target.parentNode;
            }
            x = x <= this.playerElement.clientWidth ? x : this.playerElement.clientWidth;
            y = y <= this.playerElement.clientHeight ? y : this.playerElement.clientHeight;

            return { x: x, y: y };
        },
        showMenu: function showMenu(evt) {
            // Offset relative to player element
            var off = this.getOffset(evt);

            this.el.style.left = off.x + 'px';
            this.el.style.top = off.y + 'px';

            utils.addClass(this.playerElement, 'jw-flag-rightclick-open');
            utils.addClass(this.el, 'jw-open');
            return false;
        },

        hideMenu: function hideMenu() {
            if (this.mouseOverContext) {
                // If mouse is over the menu, do nothing
                return;
            }
            utils.removeClass(this.playerElement, 'jw-flag-rightclick-open');
            utils.removeClass(this.el, 'jw-open');
        },

        lazySetup: function lazySetup() {
            if (this.el) {
                return;
            }

            this.el = this.buildMenu();

            this.layer.appendChild(this.el);

            this.hideMenuHandler = this.hideMenu.bind(this);
            this.addOffListener(this.playerElement);
            this.addOffListener(document);

            // Update the menu if the provider changes
            this.model.on('change:provider', this.updateHtml, this);

            // Track if the mouse is above the menu or not
            this.elementUI = new UI(this.el, { 'useHover': true }).on('over', function () {
                this.mouseOverContext = true;
            }, this).on('out', function () {
                this.mouseOverContext = false;
            }, this);
        },

        setup: function setup(_model, _playerElement, layer) {
            this.playerElement = _playerElement;
            this.model = _model;
            this.mouseOverContext = false;
            this.layer = layer;

            // Defer the rest of setup until the first click
            if (!utils.isPoorIE()) {
                _playerElement.oncontextmenu = this.rightClick.bind(this);
            }
        },

        addOffListener: function addOffListener(element) {
            utils.addEventListener(element, 'mousedown', this.hideMenuHandler);
            utils.addEventListener(element, 'touchstart', this.hideMenuHandler);
            utils.addEventListener(element, 'pointerdown', this.hideMenuHandler);
        },

        removeOffListener: function removeOffListener(element) {
            utils.removeEventListener(element, 'mousedown', this.hideMenuHandler);
            utils.removeEventListener(element, 'touchstart', this.hideMenuHandler);
            utils.removeEventListener(element, 'pointerdown', this.hideMenuHandler);
        },

        destroy: function destroy() {
            if (this.el) {
                this.hideMenu();
                this.elementUI.off();
                this.removeOffListener(this.playerElement);
                this.removeOffListener(document);
                this.hideMenuHandler = null;
                this.el = null;
            }

            if (this.playerElement) {
                this.playerElement.oncontextmenu = null;
                this.playerElement = null;
            }

            if (this.model) {
                this.model.off('change:provider', this.updateHtml);
                this.model = null;
            }
        }
    });

    return RightClick;
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/js/view/rightclick.js
 ** module id = 203
 ** module chunks = 0
 **/